import React, { Component, Fragment } from "react";
import { withRouter } from "react-router-dom";
import Header from "../preapps/Header";
import { getBanks, addBank, updateBank } from "../../api/index";
import "../../../sass/banks.scss";

class Bank extends Component {
    constructor(props) {
        super(props);
        this.state = {
            banks: {},
            bank_name: "",
            bank_image: "",
            edit_mode: false,
            edit_id: "",
            updated_name: "",
            updated_status: 1,
        };
    }
    componentDidMount() {
        this.getList();
    }

    getList() {
        getBanks()
            .then((response) => {
                this.setState({ banks: response.data });
            })
            .catch((error) => console.log(error));
    }

    handleChange() {
        let change = {};
        change[event.target.name] = event.target.value;
        this.setState(change);
    }

    handleSubmit() {
        if (this.state.bank_name) {
            let data = {};
            data.name = this.state.bank_name;
            addBank(data)
                .then((response) => {
                    this.state.banks.push(response.data);
                    this.setState({ bank_name: "" });
                })
                .catch((error) => console.log(error));
        }
    }

    handleEdit(element) {
        this.setState({
            edit_mode: true,
            edit_id: element.id,
            updated_name: element.name,
            updated_status: element.status,
        });
    }
    convertBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = () => {
                resolve(fileReader.result);
            };
            fileReader.onerror = (error) => {
                reject(error);
            };
        });
    };
    handleLogoChange = async (event) => {
        const file = event.target.files[0];
        const base64 = await this.convertBase64(file);
        this.setState({
            bank_image: base64,
        });
    };

    handleEditChange() {
        let change = {};
        if (event.target.name == "updated_status") {
            change[event.target.name] = !this.state.updated_status;
        } else {
            change[event.target.name] = event.target.value;
        }
        this.setState(change);
    }

    handleCancel() {
        this.setState({
            edit_mode: false,
            edit_id: "",
            updated_name: "",
            updated_status: 1,
        });
    }

    handleUpdate(element, key) {
        let data = {};
        data.id = element.id;
        data.name = this.state.updated_name;
        data.bank_image = this.state.bank_image;
        data.status = this.state.updated_status;
        updateBank(data)
            .then((response) => {
                this.state.banks[key] = response.data;
                this.setState({
                    edit_mode: false,
                    edit_id: "",
                    updated_name: "",
                    updated_status: 1,
                });
            })
            .catch((error) => console.log(error));
    }

    render() {
        const {
            banks,
            bank_name,
            edit_mode,
            edit_id,
            updated_name,
            updated_status,
        } = this.state;

        return (
            <div className="banks">
                <div className="panel panel-default">
                    <div className="panel-heading">
                        <h4 className="panel-title">Add Processors</h4>
                    </div>
                    <div className="panel-body">
                        <div className="">
                            <div className="panel-body">
                                <div className="row">
                                    <div className="col-xs-12 col-sm-12 col-md-1 col-lg-1">
                                        <label>Processors Name</label>
                                    </div>
                                    <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                                        <input
                                            type="text"
                                            name="bank_name"
                                            value={bank_name}
                                            className="form-control"
                                            onChange={(e) =>
                                                this.handleChange()
                                            }
                                        />
                                    </div>
                                    <div className="col-xs-12 col-sm-12 col-md-2 col-lg-2">
                                        <button
                                            className="btn btn-primary"
                                            onClick={(e) => this.handleSubmit()}
                                        >
                                            Submit
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="panel panel-default">
                    <div className="panel-heading">
                        <h4 className="panel-title">Processors List</h4>
                    </div>
                    <div className="panel-body">
                        <table className="table">
                            <thead>
                                <tr>
                                    <th>S.No</th>
                                    <th>Status</th>
                                    <th>Image</th>
                                    <th>Processors Name</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {Object.entries(banks).map((element, k) => (
                                    <tr key={element[1].id}>
                                        <td
                                            className={
                                                element[1].status == 1 ||
                                                edit_mode
                                                    ? ""
                                                    : "text-muted"
                                            }
                                        >
                                            {element[1].id}
                                        </td>

                                        {edit_mode &&
                                        edit_id == element[1].id ? (
                                            <td>
                                                {" "}
                                                <input
                                                    type="checkbox"
                                                    name="updated_status"
                                                    value={
                                                        this.state
                                                            .updated_status
                                                    }
                                                    onChange={(e) =>
                                                        this.handleEditChange()
                                                    }
                                                />
                                            </td>
                                        ) : (
                                            <td>
                                                {" "}
                                                <input
                                                    type="checkbox"
                                                    name="bank_status"
                                                    value={element[1].status}
                                                    disabled={
                                                        element[1].status == 0
                                                    }
                                                    checked={
                                                        element[1].status == 1
                                                    }
                                                />
                                            </td>
                                        )}

                                        {edit_mode &&
                                        edit_id == element[1].id ? (
                                            <td>
                                                <input
                                                    type="file"
                                                    id="logo"
                                                    name="logo"
                                                    accept="image/png, image/jpeg"
                                                    onChange={(e) =>
                                                        this.handleLogoChange(e)
                                                    }
                                                />
                                            </td>
                                        ) : (
                                            <td>
                                                <img
                                                    className="bankImage"
                                                    src={
                                                        "bank-image/" +
                                                        element[1].id
                                                    }
                                                ></img>
                                            </td>
                                        )}
                                        {edit_mode &&
                                        edit_id == element[1].id ? (
                                            <td>
                                                {" "}
                                                <input
                                                    type="text"
                                                    name="updated_name"
                                                    value={updated_name}
                                                    className="form-control"
                                                    onChange={(e) =>
                                                        this.handleEditChange()
                                                    }
                                                />
                                            </td>
                                        ) : (
                                            <td
                                                className={
                                                    element[1].status == 1
                                                        ? ""
                                                        : "text-muted"
                                                }
                                            >
                                                {element[1].name}
                                            </td>
                                        )}
                                        <td>
                                            {edit_mode &&
                                            edit_id == element[1].id ? (
                                                <div className="actions-btn">
                                                    <button
                                                        className="btn btn-success"
                                                        onClick={(e) =>
                                                            this.handleUpdate(
                                                                element[1],
                                                                k,
                                                            )
                                                        }
                                                    >
                                                        Update
                                                    </button>
                                                    <button
                                                        className="btn btn-success"
                                                        onClick={(e) =>
                                                            this.handleCancel()
                                                        }
                                                    >
                                                        Cancel
                                                    </button>
                                                </div>
                                            ) : (
                                                <button
                                                    className="btn btn-success"
                                                    onClick={(e) =>
                                                        this.handleEdit(
                                                            element[1],
                                                        )
                                                    }
                                                >
                                                    Edit
                                                </button>
                                            )}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        );
    }
}

export default Bank;
